// extracted by css-extract-rspack-plugin
export default {"noResultContainer":"NoAccommodationCard-module__noResultContainer","title":"NoAccommodationCard-module__title","description":"NoAccommodationCard-module__description"};